/*
 * Copyright (c) 2026. Tooling Team
 */

import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useGetMedDomainBuildDiffMutation } from "../app/services/medDomainApi";
import { setMedDomainBuildDiffData } from "../app/slices/medDomain.slice";
import { addUniqueId } from "../utils/funcs";

export default ({ groupId, newBuildId, oldBuildId, reloadKey }) => {
  const { medDomainBuildDiffData } = useSelector((state) => state.medDomain);
  const dispatch = useDispatch();
  const lastRequestRef = useRef("");
  const lastParamsRef = useRef("");

  const [getMedDomainBuildDiff, { data: diffData, isLoading }] =
    useGetMedDomainBuildDiffMutation();

  // Clear previous diff data when the diff parameters change
  useEffect(() => {
    if (!groupId || !newBuildId || !oldBuildId) return;

    const paramsKey = `${groupId}-${newBuildId}-${oldBuildId}`;
    if (lastParamsRef.current !== paramsKey) {
      // null indicates "not loaded yet"
      dispatch(setMedDomainBuildDiffData(null));
      lastParamsRef.current = paramsKey;
    }
  }, [groupId, newBuildId, oldBuildId, dispatch]);

  useEffect(() => {
    if (!groupId || !newBuildId || !oldBuildId) {
      return;
    }

    const requestKey = `${groupId}-${newBuildId}-${oldBuildId}-${
      reloadKey ?? ""
    }`;
    if (lastRequestRef.current === requestKey) {
      return;
    }

    getMedDomainBuildDiff({ groupId, newBuildId, oldBuildId });
    lastRequestRef.current = requestKey;
  }, [groupId, newBuildId, oldBuildId, reloadKey, getMedDomainBuildDiff]);

  useEffect(() => {
    // New response shape: always an object; when diff exists, diffResults is an array
    if (diffData && Array.isArray(diffData.diffResults)) {
      dispatch(setMedDomainBuildDiffData(addUniqueId(diffData.diffResults)));
    }
  }, [diffData, dispatch]);

  return {
    state: {
      medDomainBuildDiffData,
      rawDiffResponse: diffData,
    },
    isLoadingDiff: isLoading,
  };
};
